module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"firstName":"Имя","lastName":"Фамилия","phone":"Телефон","notifyByEmail":"Оповестить по электронной почте","invite":"Далее","cancel":"Отменить","resume":"Резюме","sizeWarning":"Размер резюме не должне превышать","searchTitle":"Существующие кандидаты","candidateNotFound":"Такой кандидат не найден. Будет создан новый кандидат"}}')
  delete Component.options._Ctor
}
